<template>
  <div class="seller-auth-shell">
    <section class="seller-auth-hero">
      <p class="eyebrow">dashcom seller studio</p>
      <h1>进入卖家工作台，继续管理商品与订单。</h1>
      <p>库存、营销、物流、客户和 AI 试衣配置都集中在一个更轻盈的后台界面里。</p>
    </section>

    <div class="seller-auth-card card">
      <h2>卖家登录</h2>

      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <form @submit.prevent="login">
        <div class="form-group">
          <label for="username">用户名</label>
          <input id="username" v-model="username" type="text" required placeholder="请输入卖家账号">
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input id="password" v-model="password" type="password" required placeholder="请输入密码">
        </div>
        <button type="submit" class="btn primary-btn">登录</button>
        <div class="form-footer">
          还没有账号？
          <router-link to="/seller/register">立即注册</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerLogin',
  data() {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  created() {
    if (localStorage.getItem('sellerToken')) {
      this.$router.push('/seller/dashboard')
    }
    if (localStorage.getItem('customerToken')) {
      this.error = '请先退出用户端账号后再登录卖家端'
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    }
  },
  methods: {
    async login() {
      try {
        const response = await this.$axios.post('/seller/login', null, {
          params: {
            username: this.username,
            password: this.password
          }
        })

        if (response.data.success && response.data.token) {
          localStorage.setItem('sellerToken', response.data.token)
          localStorage.setItem('sellerUsername', response.data.username)
          localStorage.setItem('sellerId', response.data.sellerId)
          localStorage.setItem('shopName', response.data.shopName)
          this.$router.push('/seller/dashboard')
        } else {
          this.error = response.data.message || '用户名或密码错误'
        }
      } catch (err) {
        this.error = '登录失败，请重试'
        console.error(err)
      }
    }
  }
}
</script>

<style scoped>
.seller-auth-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(380px, 470px);
  gap: 1.4rem;
  align-items: stretch;
  min-height: calc(100vh - 220px);
}

.seller-auth-hero,
.seller-auth-card {
  border-radius: 32px;
}

.seller-auth-hero {
  padding: 2rem;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.32)),
    radial-gradient(circle at 18% 20%, rgba(0, 113, 227, 0.16), transparent 30%),
    linear-gradient(180deg, rgba(250, 250, 252, 0.95), rgba(236, 239, 244, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-medium);
}

.eyebrow {
  margin: 0 0 0.8rem;
  color: var(--color-text-faint);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.seller-auth-hero h1 {
  margin: 0;
  max-width: 11ch;
  font-size: clamp(2.3rem, 4vw, 3.8rem);
  line-height: 1;
  letter-spacing: -0.05em;
  color: var(--color-text);
}

.seller-auth-hero p:last-child {
  max-width: 480px;
  margin: 1rem 0 0;
  color: var(--color-text-soft);
  line-height: 1.8;
}

.seller-auth-card {
  width: 100%;
  margin: 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.75);
  box-shadow: var(--shadow-soft);
}

.seller-auth-card h2 {
  margin: 0 0 1.5rem;
  color: var(--color-text);
  font-size: 1.8rem;
  letter-spacing: -0.03em;
}

.primary-btn {
  width: 100%;
  min-height: 52px;
}

.form-footer {
  margin-top: 1rem;
  text-align: center;
  color: var(--color-text-soft);
}

.form-footer a {
  color: var(--color-accent-strong);
  text-decoration: none;
  font-weight: 600;
}

.form-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .seller-auth-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .seller-auth-hero,
  .seller-auth-card {
    border-radius: 24px;
  }
}
</style>
